/* eslint-disable no-use-before-define */
import { startOfToday, startOfMonth, endOfMonth, addDays, addMonths, addYears } from 'date-fns'
import { format } from './format'

const Patterns = [{
    // mm/dd/yyyy
    re: /^(0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])[/-](\d{4})$/ig,
    fn: ([s]) => newDate(s),
    fmt: (dt) => format.mdy(dt)
},{
    // yyyy/mm/dd
    re: /^(\d{4})[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/ig,
    fn: ([s]) => newDate(s),
    fmt: (dt) => format.mdy(dt)
},{
    // mm/yy mm/yyyy
    re: /^(0?[1-9]|1[012])[/-](\d{2,4})$/ig,
    fn: ([_, m, y], eom = false) => {
        let fn = (eom ? endOfMonth : startOfMonth)
        return fn(newDate(`${m}/1/${y}`))
    },
    fmt: (dt) => format.mdy(dt)
},{
    // #mdy
    re: /(^[0-9]{1,4})([mdy])$/ig,
    fn: ([_, n, t]) => {
        let d = startOfToday()
        if (t==='d' || t==='D') return addDays(d, n)
        if (t==='m' || t==='M') return addMonths(d, n)
        if (t==='y' || t==='Y') return addYears(d, n)
    },
    fmt: (dt, str) => str.toLowerCase()
},{
    // # ####
    re: /(^[0-9]{1,4})$/ig,
    fn: ([y], eom) => {
        let n = y.length
        if (n<4) return addYears(startOfToday(), y)
        if (n===4) return newDate((eom ? '12/31/': '1/1/') + y)
    },
    fmt: (dt, str) => str
}]

export const newDate = (s) => {
    let a = Date.parse(s)
    return isNaN(a) ? null : new Date(a)
}

export const parseDate = (str, eom = false) => {
    if (!str) return

    for (let i=0, n=Patterns.length; i<n; i++) {
        let p = Patterns[i]
        p.re.lastIndex = 0

        let a = p.re.exec(str)
        if (!a) continue

        return p.fn ? p.fn(a, eom) : a
    }
}

export const formatDate = (str, eom = false) => {
    if (!str) return ''

    for (let i=0, n=Patterns.length; i<n; i++) {
        let p = Patterns[i]
        p.re.lastIndex = 0

        let a = p.re.exec(str)
        if (!a) continue

        let d = p.fn(a, eom)
        return p.fmt(d, str)
    }

    return ''
}